// eslint-disable-next-line import/prefer-default-export
export const INVOICING_ES = {
  // common
  Cancel: 'Cancelar',
  Accept: 'Aceptar',

  See: 'Ver',
  title: 'Facturación',
  CompanysPlans: 'Planes de empresas',
  All: 'Todos',
  placeholderSearchCompany: 'Buscar empresa',
  CreateNewInvoice: 'Crear nueva factura',
  Company: 'Empresa',
  Plan: 'Plan',
  InitialDate: 'Fecha inicial',
  ExpirationDate: 'Fecha de vencimiento',
  Actions: 'Acciones',

  // modalCreate
  AddInvoice: 'Agregar factura',
  WhoAddressedTo: '¿A quién está dirigida?',
  RequiresCharge: 'Requiere carga',
  placeholderSearchTemplates: 'Buscar plantillas',
  WhichMonth: '¿Para qué mes?',
  RequireCharge: 'Require cobranza',
  DropAFileHere: 'Arrastra el archivo aquí',
  AddEmail: 'Agregar email',
  AddEmailSecondary: 'Agregar email secundario',

  // modalInvoicesList
  InvoicesList: 'Lista de facturas',
  Name: 'Nombre',
  Type: 'Tipo',
  ExpeditionDate: 'Fecha de expedición',
  EntryDate: 'Fecha de ingreso',
  NoInvoices: 'Sin facturas asignadas',

  // Notifications
  InvoicesAdded: 'Facturas agregadas',
  OnlyPdfXml: 'Solo acepta archivos con extenciones .pdf o .xml',
  MustUploadFiles: 'Debe subir los archivos necesarios',
  MustSelectCompany: 'Favor de seleccionar una empresa primero.',
  ErrorUploadingFile: 'Error al subir el documento',

  // new accounts
  aggree: 'Conceder acceso',
  reject: 'Rechazar acceso',
  empty: 'Sin la información',
  textAgree: '¿Seguro que quieres otorgar esta cuenta?',
  textReject: '¿Seguro que quieres rechazar esta cuenta?',
  agree: 'De acuerdo',
  cancel: 'Cancelar',
  confirm: 'Confirmación',
  textAccept: 'Aprobación de empresas',
  companyName: 'Empresa',
  phone: 'Teléfono',
  actions: 'Acciones',
  optionFilter: 'Otras funciones',
  noData: 'No hay información disponible',
  dateAction: 'Fecha',
  txtPendingCompanies: 'Pendientes',
  txtAcceptedCompanies: 'Aceptadas',
  txtRejectedCompanies: 'Rechazadas',
  txtResponsible: 'Responsable',
  txtNameCompany: 'Nombre de la empresa',
};
